module.exports = __webpack_public_path__ + "img/35.980a3cf3.jpg";